import { fallbackLocale, Locales } from '@griply/types';

export const resolveSupportedLanguage = (
  language: Locales | undefined,
): Locales => {
  if (language && Object.values(Locales).includes(language)) {
    return language;
  }

  return fallbackLocale;
};
